import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import { IconButtonProps } from "@mui/material/IconButton";
import { BootstrapDialog } from "../circle-limited-details-modal/styles";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Collapse,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { buttonColors, colors } from "../../../utility/types/constant";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Rating from "@mui/material/Rating";
import LoadingSpinner from "../../loading-spinner/LoadingSpinner";

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme }) => ({
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
  variants: [
    {
      props: ({ expand }: any) => !expand,
      style: {
        transform: "rotate(0deg)",
      },
    },
    {
      props: ({ expand }: any) => !!expand,
      style: {
        transform: "rotate(180deg)",
      },
    },
  ],
}));

interface PartialUserProfileModalProps {
  sx?: any;
  title?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  dateOfBirth?: string;
  profileImage?: string;
  reason?: string;
  open: boolean;
  onApprove: () => any;
  onDenyOrReject: () => void;
  handleClose: () => void;
  rating?: number;
}

const PartialUserProfileModal = (props: PartialUserProfileModalProps) => {
  const {
    sx,
    title,
    open,
    handleClose,
    onApprove,
    onDenyOrReject,
    firstName,
    lastName,
    email,
    dateOfBirth,
    reason,
    profileImage,
    rating,
  } = props;

  const [expanded, setExpanded] = useState(false);

  const [showLoading, setShowLoading] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  // const handleApprove = async () => {
  //   setShowLoading(true);
  //   try {
  //     await onApprove();
  //   } catch (error) {
  //     // Optionally handle error here
  //   } finally {
  //     setShowLoading(false);
  //     handleClose();
  //   }
  // };

  // const handleDeny = async () => {
  //   setShowLoading(true);
  //   try {
  //     await onDenyOrReject();
  //   } catch (error) {
  //     // Optionally handle error here
  //   } finally {
  //     setShowLoading(false);
  //     handleClose();
  //   }
  // };

  const handleApprove = async () => {
    await onApprove();
  };

  const handleDeny = async () => {
    await onDenyOrReject();
  };

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleClose}
        open={open}
        aria-labelledby="customized-dialog-title"
        maxWidth="lg"
        fullWidth
        sx={{
          ...sx,
          width: "80",
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2, fontSize: "1.5rem" }}
          id="customized-dialog-title"
        >
          {title}
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: colors.white,
            backgroundColor: colors.cancel,
            "&:hover": {
              color: colors.white,
              backgroundColor: colors.cancel,
            },
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers sx={{ fontSize: "1.1rem" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Card sx={{ maxWidth: 600, width: "100%" }}>
              <CardHeader
                avatar={
                  <Avatar
                    sx={{ bgcolor: colors.infoDarkBlue }}
                    aria-label="recipe"
                  >
                    {firstName?.substring(0, 1)}
                  </Avatar>
                }
                title={`${firstName} ${lastName}`}
              />
              <CardMedia
                component="img"
                // height="10%"
                image={profileImage}
                alt={firstName}
                sx={{
                  maxHeight: 350,
                }}
              />
              <CardContent></CardContent>
              <CardActions disableSpacing>
                <ExpandMore
                  expand={expanded}
                  onClick={handleExpandClick}
                  aria-expanded={expanded}
                  aria-label="show more"
                >
                  <ExpandMoreIcon />
                </ExpandMore>
              </CardActions>
              <Collapse in={expanded} timeout="auto" unmountOnExit>
                <CardContent>
                  <Typography
                    sx={{ marginBottom: 2, fontSize: 20, fontWeight: 800 }}
                  >
                    Reason For Joining:
                  </Typography>
                  <Typography sx={{ marginBottom: 2 }}>
                    {reason && reason.length > 0 ? reason : "N/A"}
                  </Typography>
                  <Typography
                    sx={{ marginBottom: 2, fontSize: 20, fontWeight: 800 }}
                  >
                    Rating:
                  </Typography>
                  <Typography sx={{ marginBottom: 2 }}>
                    <Rating
                      name="read-only"
                      value={rating || 0}
                      readOnly
                      precision={0.1}
                    />
                  </Typography>
                </CardContent>
              </Collapse>
            </Card>
          </Box>
        </DialogContent>

        {/* <DialogActions sx={{ justifyContent: "center" }}>
          <Stack direction="row" spacing={10}>
            <Button
              size="large"
              onClick={handleApprove}
              variant="contained"
              sx={{
                bgcolor: buttonColors.secondPrimary,
                color: colors.white,
                "&:hover": {
                  bgcolor: buttonColors.secondPrimary,
                  color: colors.white,
                },
              }}
              disabled={showLoading}
            >
              {showLoading ? (
                <LoadingSpinner
                  loading={showLoading}
                  sx={{ color: colors.white }}
                  size={30}
                  color={colors.white}
                />
              ) : (
                "Accept"
              )}
            </Button>

            <Button
              size="large"
              onClick={handleDeny}
              variant="contained"
              sx={{
                bgcolor: buttonColors.persianRed,
                color: colors.white,
                "&:hover": {
                  bgcolor: buttonColors.persianRed,
                  color: colors.white,
                },
              }}
              disabled={showLoading}
            >
              {showLoading ? (
                <LoadingSpinner
                  loading={showLoading}
                  sx={{ color: colors.white }}
                  size={30}
                  color={colors.white}
                />
              ) : (
                "Deny"
              )}
            </Button>
          </Stack>
        </DialogActions> */}
      </BootstrapDialog>
    </React.Fragment>
  );
};

PartialUserProfileModal.prototype = {
  title: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  sx: PropTypes.any,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  onApprove: PropTypes.func.isRequired,
  onDenyOrReject: PropTypes.func.isRequired,
  profileImage: PropTypes.string,
};

export default PartialUserProfileModal;
